import api from './api';
import { TDSListResponse } from '../types/tds';

export const tdsService = {
    // GET /api/site/tds?page=1&limit=10
    list: async (params?: {
        page?: number;
        limit?: number;
        search?: string;
    }): Promise<TDSListResponse> => {
        const response = await api.get('tds', { params });
        return response.data;
    },

    // GET /api/site/tds/:id
    getById: async (id: string): Promise<{ success: boolean; data: any }> => {
        const response = await api.get(`tds/${id}`);
        return response.data;
    },
};
